import React, { useState, useEffect } from 'react';
import ModalContent from './ModalContent';

interface Props {
  buttonClass?: string;
  button: React.ReactNode;
  content: React.ReactNode;
  contentTitle: React.ReactNode;
  modalClass: string;
  icon?: React.ReactNode;
  ariaLabel?: string;
}

const Modal = ({
  buttonClass,
  button,
  content,
  contentTitle,
  modalClass,
  icon,
  ariaLabel,
}: Props) => {
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    return () => {
      document.querySelector('body').classList.remove('scroll-lock');
    };
  }, []);

  const openModal = () => {
    setModalOpen(true);
    document.querySelector('body').classList.add('scroll-lock');
  };

  const closeModal = () => {
    setModalOpen(false);
    document.querySelector('body').classList.remove('scroll-lock');
  };

  return (
    <>
      <button
        className={buttonClass}
        onClick={openModal}
        type="button"
        aria-label={ariaLabel}
      >
        {icon}
        {button}
      </button>
      {modalOpen && (
        <ModalContent
          content={content}
          contentTitle={contentTitle}
          closeModal={closeModal}
          modalClass={modalClass}
        />
      )}
    </>
  );
};

export default Modal;
